export const BookingInfoParagraph = ({ 
	title, 
	children 
}: {
	title: string;
	children: React.ReactNode;
}) => (
	<div className="betting-info__group">
		<div className="betting-info__label">{title}</div>
		<div className="betting-info__amount">{children}</div>
	</div>
);